import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faChartLine, faDownload, faUpload, faPiggyBank, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const FinancesHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faDollarSign} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Finances Guide</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>💰 Money makes the world go 'round! Smart financial management is the backbone of a championship dynasty. Master your budget and unlock your team's potential!</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faDollarSign} style={{ marginRight: '8px', color: 'var(--info-color)' }} />Financial Overview</h3>
            <p><strong>Key metrics:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Total Balance:</strong> Available cash for transfers and investments</li>
                <li><strong>Last Week Net:</strong> Income minus expenditure (positive means profit)</li>
                <li><strong>Last Week Income:</strong> Prize money, sponsorships, player sales</li>
                <li><strong>Last Week Expenditure:</strong> Salaries, facilities, transfer fees</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Keep your balance positive to maintain club stability</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faChartLine} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Income Sources</h3>
            <p><strong>Where your money comes from:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>League Prize Money:</strong> Awarded based on final position (1st place gets most)</li>
                <li><strong>Cup Prize Money:</strong> Earned from winning cup matches and competitions</li>
                <li><strong>Sponsorship Deals:</strong> Regular income from shirt sponsors and partners</li>
                <li><strong>Player Sales:</strong> Selling players to other teams (one-time payment)</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Expenses</h3>
            <p><strong>What costs money:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Player Salaries:</strong> Weekly wages paid to squad members (biggest expense)</li>
                <li><strong>Facility Maintenance:</strong> Upkeep of training grounds and stadium</li>
                <li><strong>Transfer Fees:</strong> Cost to sign players from other teams</li>
                <li><strong>Youth Development:</strong> Investment in academy facilities</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>High wages are necessary to attract better players but drain your budget</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Transaction History</h3>
            <p><strong>Track all financial activity:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Season and week of each transaction</li>
                <li>Event description (what triggered the payment)</li>
                <li>Amount (positive = income, negative = expense)</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Review your history to identify spending patterns and optimize your budget</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faPiggyBank} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Smart Money Strategy</h3>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>💵 <strong>Build a Buffer:</strong> Always maintain a positive balance for emergencies and opportunities</li>
                <li>📊 <strong>Sell Smart:</strong> Trade surplus players strategically to fund key signings</li>
                <li>⚖️ <strong>Watch Your Wages:</strong> Keep wage bill at 60-70% of weekly income - don't overspend!</li>
                <li>📈 <strong>Invest in Wins:</strong> Prize money from competitions multiplies your income</li>
                <li>🎯 <strong>Think Long-Term:</strong> Balance immediate needs with future sustainability</li>
                <li>🏆 <strong>Climb Divisions:</strong> Higher leagues = bigger sponsorship deals and prize pools</li>
            </ul>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
